<template>
  <div :class="getScreen ? 'm-page-wrapper' : 'd-page-wrapper'">
    <div v-if="id === null || id === undefined">
      <a-card class="m-wrong">
        <m-anim
          :options="notfound"
          class="anim"
          :height="getScreen ? 200 : 500"
          :width="getScreen ? 200 : 500"
        ></m-anim>
        <h3>Not Found</h3>
        <p>
          Return to the previous page and make the selection manifest again!
        </p>
        <a-button type="primary" block @click="$router.go(-1)">
          <a-icon type="rollback" />&nbsp; Return
        </a-button>
      </a-card>
    </div>
    <div v-else>
      <a-row :gutter="8">
        <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
          <a-card :loading="pageLoading" class="margin-bottom">
            <div slot="title">
              <h4 class="margin-remove">OVERBOOKING MANIFEST</h4>
              <small>{{ data.header_1.am_no }}</small>
            </div>
            <a-popover slot="extra" trigger="click" placement="bottom">
              <span slot="title">Select Action</span>
              <ul class="m-list-wrapper bordered" slot="content">
                <li>
                  <a-button
                    type="primary"
                    size="small"
                    icon="printer"
                    block
                    ghost
                    @click="handlePrint"
                    disabled
                    class="m-display-block"
                    >Manifest</a-button
                  >
                </li>
                <li v-if="getAuth.username == data.user_pembuat.tlc">
                  <!-- <a-button-group> -->
                  <a-button
                    :disabled="
                      !(
                        data.last_status == 'Revised' &&
                        getAuth.username == data.user_pembuat.tlc
                      )
                    "
                    @click="handleEdit"
                    type="dashed"
                    size="small"
                    icon="edit"
                    block
                    class="m-display-block"
                    >Edit</a-button
                  >
                  <!-- </a-button-group> -->
                </li>
              </ul>
              <a-button icon="more">Action</a-button>
            </a-popover>

            <div class="m-card-body">
              <ul class="m-list-wrapper bordered">
                <li>
                  <span class="m-list-title" for>Created Date</span>
                  <span class="m-list-desc">{{
                    moment(data.header_1.create_dt).format(getDefaultDateFormat)
                  }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>User Creator</span>
                  <span class="m-list-desc">{{
                    data.header_1.tlc_create
                  }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Account From</span>
                  <span class="m-list-desc">{{ data.header_1.acc_from }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Value</span>
                  <span class="m-list-desc">{{
                    formatCurrency(data.header_1.currency, data.header_1.value)
                  }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Kurs</span>
                  <span class="m-list-desc">{{
                    formatCurrency(data.currency_to, data.header_1.kurs)
                  }}</span>
                </li>
                <!-- <li>
                  <span class="m-list-title" for>Description</span>
                  <span
                    class="m-list-desc"
                  >{{data.header_1.description}}</span>
                </li> -->
                <li>
                  <span class="m-list-title" for>Account to</span>
                  <span class="m-list-desc">{{ data.header_1.acc_to }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Currency to</span>
                  <span class="m-list-desc">{{ data.currency_to }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Description </span>
                  <span class="m-list-desc">{{
                    data.header_1.description
                  }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Document</span>
                  <span class="m-list-desc margin-top">
                    <a-button
                      class="margin-top ant-menu-submenu ant-menu-submenu-selected"
                      icon="download"
                      size="default"
                      @click="handlePreview(data.header_1.file_path)"
                      v-if="data.header_1.file_name"
                    >View Document</a-button>
                    <span v-else>-</span>
                  </span>
                </li>
              </ul>
            </div>
          </a-card>
          <!-- <a-collapse class="margin-top" activeKey="1">
            <a-collapse-panel key="1">
              <h4 slot="header" class="margin-remove">Other Cost</h4>
              <a-input-search
                v-model="search"
                placeholder="Quick Search"
                allowClear
                :change="searching"
                class="margin-bottom"
              />
              <a-table
                :columns="columns"
                :dataSource="tableData"
                :pagination="pagination"
                size="small"
                bordered
                :scroll="{ x: 100 }"
              >
                <span slot="jmlbarang" slot-scope="jmlbarang">
                  <div style="text-align: center; width: 100%">
                    {{ jmlbarang.jumlah_barang }} {{ jmlbarang.satuan }}
                  </div>
                </span>
                <span slot="harga" slot-scope="harga">
                  <CurrencyJustified
                    v-if="harga"
                    :currencyValue="data.currency"
                    :valueNumber="harga"
                  />
                  <div v-else style="text-align: center; width: 100%">-</div>
                </span>
                <span slot="total" slot-scope="sisa">
                  <CurrencyJustified
                    :currencyValue="data.currency"
                    :valueNumber="sisa"
                  />
                </span>

                <div slot="footer">
                  <a-row type="flex">
                    <a-col :span="7" :order="1" class="m-text-align left"
                      ><h3>Grand Total</h3></a-col
                    >
                    <a-col
                      :span="7"
                      :order="2"
                      class="m-text-align left m-text-bold"
                    >
                      <h3>
                        {{
                          formatCurrency(
                            data.currency,
                            Number(data.header_1.value)
                          )
                        }}
                      </h3>
                    </a-col>
                  </a-row>
                </div>
              </a-table>
            </a-collapse-panel>
          </a-collapse> -->

          <template>
            <a-card
              class="margin-top"
              :loading="pageLoading"
              v-if="
                data.jenis.toLowerCase() !== 'manifest' &&
                data.jenis.toLowerCase() !== 'transfer'
              "
            >
              <div slot="title">Manifest Actions</div>

              <a-form :form="form">
                <a-form-item label="Note">
                  <a-textarea
                    placeholder="Write the note here ... "
                    :rows="4"
                    v-decorator="['catatan']"
                  />
                </a-form-item>
                <a-form-item label="Aksi" v-if="data.aksi">
                  <a-select
                    showSearch
                    v-decorator="['aksi', { rules: [{ required: true }] }]"
                  >
                    <a-select-option
                      v-for="item in data.aksi"
                      :key="item.aksi"
                      >{{ item.aksi }}</a-select-option
                    >
                  </a-select>
                </a-form-item>
              </a-form>
              <template class="ant-card-actions" slot="actions">
                <a-button
                  @click="handleActionConfirm"
                  block
                  type="primary"
                  html-type="submit"
                  >Save</a-button
                >
              </template>
            </a-card>
            <a-card
              class="margin-top"
              :loading="pageLoading"
              v-if="data.jenis.toLowerCase() === 'transfer'"
            >
              <div slot="title">
                Manifest Actions &nbsp;<i
                  v-if="data.jenis == 'Transfer' && !data.status_transfer"
                  style="color: red !important"
                  >(Funding has not been set)</i
                >
              </div>
              <div slot="extra">
                <h5 class="m-text-align right margin-remove">
                  Remaining Balance
                </h5>
                <a-tag color="green">
                  {{ formatCurrency(data.currency, data.sisa_tf) }}
                </a-tag>
              </div>
              <template
                v-if="!(data.jenis == 'Transfer' && !data.status_transfer)"
              >
                <a-form :form="form">
                  <a-form-item label="Aksi" v-if="data.aksi">
                    <a-select
                      @change="changeAction"
                      showSearch
                      v-decorator="[
                        'status',
                        {
                          rules: [{ required: true }],
                          initialValue: 'Transferred',
                        },
                      ]"
                    >
                      <a-select-option
                        v-for="item in data.aksi"
                        :key="item.aksi"
                        >{{ item.aksi }}</a-select-option
                      >
                    </a-select>
                  </a-form-item>
                  <a-form-item
                    label="Transfer Date"
                    v-if="aksiSelected === 'Transferred' || aksiSelected === ''"
                  >
                    <a-date-picker
                      placeholder="Select Date"
                      :format="getDefaultDateFormat"
                      v-decorator="['tgl_trf', { rules: [{ required: true }] }]"
                    />
                  </a-form-item>
                  <a-form-item
                    label="Evidence of Transfer"
                    v-if="aksiSelected === 'Transferred' || aksiSelected === ''"
                  >
                    <a-upload
                      accept="image/*"
                      :showUploadList="true"
                      :fileList="push"
                      listType="picture"
                      :beforeUpload="beforeUpload"
                      :remove="handleRemoveList"
                      v-decorator="[
                        'upload',
                        { rules: [{ required: true }] },
                        { valuePropName: 'push' },
                      ]"
                    >
                      <a-button>
                        <a-icon type="upload" />&nbsp;Select File
                      </a-button>
                    </a-upload>
                  </a-form-item>
                  <a-form-item
                    label="Transfer Value"
                    v-if="aksiSelected === 'Transferred' || aksiSelected === ''"
                  >
                    <a-input-number
                      :disabled="disabled"
                      :max="data.sisa_tf"
                      class="m-width-full m-text-align right"
                      v-decorator="[
                        'value_transferan',
                        {
                          rules: [{ required: true }],
                          initialValue: data.sisa_tf,
                        },
                      ]"
                      :formatter="
                        (value) =>
                          `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                      "
                    />
                  </a-form-item>
                  <a-checkbox
                    v-if="aksiSelected === 'Transferred' || aksiSelected === ''"
                    class="margin-bottom"
                    disabled
                    @change="handleCheckData"
                    :checked="checkTransferValue"
                    >The transferred value matches the remaining
                    balance</a-checkbox
                  >
                  <a-form-item label="Note">
                    <a-textarea
                      placeholder="Write the note here ... "
                      :rows="4"
                      v-decorator="['remark']"
                    />
                  </a-form-item>
                </a-form>
                <template class="ant-card-actions" slot="actions">
                  <a-button
                    @click="handleActionConfirm"
                    block
                    type="primary"
                    html-type="submit"
                    >Save</a-button
                  >
                </template>
              </template>
            </a-card>
          </template>
        </a-col>
        <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
          <a-card :loading="pageLoading" :class="getScreen ? 'margin-top' : ''">
            <div slot="title">Evidence of Transfer</div>
            <div>
              <a-alert
                v-if="data.bukti_transfer.length <= 0"
                type="error"
                message="No evidence of transfer was uploaded"
                banner
              />
              <a-list
                itemLayout="horizontal"
                :dataSource="data.bukti_transfer"
                v-else
              >
                <Empty
                  v-if="
                    data.bukti_transfer
                      ? data.bukti_transfer.length <= 0
                      : data.bukti_transfer
                  "
                />
                <a-list-item slot="renderItem" slot-scope="item">
                  <a-list-item-meta>
                    <div
                      slot="title"
                      class="m-display-flex space-between align-middle nowrap"
                    >
                      <h4 class="margin-remove m-text-dots">
                        {{ moment(item.tgl_tf).format('DD-MM-YYYY') }} | {{ item.tlc }}
                      </h4>
                      <a-button
                        @click="handleViewDt(item)"
                        size="small"
                        type="default"
                        icon="eye"
                        >View</a-button
                      >
                    </div>
                    <p slot="description">
                      {{ data.currency + ". " + item.value_tf }}
                    </p>
                  </a-list-item-meta>
                </a-list-item>
              </a-list>
            </div>
          </a-card>
          <!-- <a-collapse :class="'margin-top'" activeKey="1">
            <a-collapse-panel key="1">
              <div class="m-display-flex space-between align-middle" slot="header">
                <h4 class="margin-remove">Dokumen Pendukung</h4>
              </div>
              <a-list itemLayout="horizontal" :dataSource="data.dokumen_pendukung">
                <Empty v-if="data.dokumen_pendukung ? data.dokumen_pendukung.length<=0 : data.dokumen_pendukung" />
                <a-list-item slot="renderItem" slot-scope="item">
                  <a-list-item-meta>
                    <div slot="title" class="m-display-flex space-between align-middle">
                      <h4 class="m-list-dots margin-removes">{{item.file_name}}</h4>
                      <a-button
                        size="small"
                        type="default"
                        icon="cloud-download"
                        @click="handleDownload(item)"
                      ></a-button>
                    </div>
                    <p
                      slot="description"
                      :class="getScreen ? 'm-list-dots' : ''"
                    >{{item.catatan}}</p>
                    <img class="m-image-icon" slot="avatar" src="@/assets/icon/pdf_ico.png" />
                  </a-list-item-meta>
                </a-list-item>
              </a-list>
            </a-collapse-panel>
          </a-collapse> -->
          <a-collapse class="margin-top" activeKey="1">
            <a-collapse-panel key="1">
              <div
                class="m-display-flex space-between align-middle"
                slot="header"
              >
                <h4 class="margin-remove">Status</h4>
                <div>
                  <Status :status="data.last_status" />
                  <a-button
                    @click="historyToggle"
                    type="default"
                    size="small"
                    class="margin-right-small"
                  >
                    History
                    <a-icon type="undo" />
                  </a-button>
                </div>
              </div>
              <a-timeline class="m-timeline">
                <a-spin :spinning="pageLoading">
                  <a-timeline-item
                    v-for="workflow in data.status"
                    :key="workflow.step_no"
                    :color="
                      workflow.status === 'On Process' ||
                      workflow.status === 'Delivered'
                        ? 'red'
                        : workflow.status === 'Waiting'
                        ? 'grey'
                        : 'green'
                    "
                  >
                    <div class="m-timeline-title">
                      {{ workflow.actor ? workflow.actor : workflow.job_desc }}
                      {{ workflow.tlc ? " - " + workflow.tlc : "" }}
                    </div>
                    <div class="m-timeline-body">
                      <h4 class="margin-remove" v-if="workflow.tanggal_aksi">
                        {{
                          moment(workflow.tanggal_aksi).format(
                            getDateTimeFormat
                          )
                        }}
                      </h4>
                      <span class="m-text-small" v-if="workflow.remark">{{
                        workflow.remark
                      }}</span>
                      <span class="m-text-small" v-else>Tidak Ada Catatan</span>
                    </div>
                    <div class="m-timeline-footer">
                      <Status :status="workflow.status" />
                    </div>
                  </a-timeline-item>
                </a-spin>
              </a-timeline>
            </a-collapse-panel>
          </a-collapse>
          <a-collapse class="margin-top" activeKey="1">
            <a-collapse-panel key="1">
              <div
                class="m-display-flex space-between align-middle"
                slot="header"
              >
                <h4 class="margin-remove">Related Document</h4>
              </div>

              <a-list
                itemLayout="horizontal"
                :dataSource="data.dokumen_terkait"
              >
                <Empty
                  v-if="
                    data.dokumen_terkait
                      ? data.dokumen_terkait.length <= 0
                      : data.dokumen_terkait
                  "
                />
                <a-list-item slot="renderItem" slot-scope="item">
                  <a-list-item-meta>
                    <div
                      slot="title"
                      class="m-display-flex space-between align-middle"
                    >
                      <a @click="handleViews(item)"
                        >{{ item.header }} | {{ item.tlc }}</a
                      >
                      <Status
                        :class="!getScreen ? 'margin-remove' : ''"
                        :status="item.status"
                      />
                    </div>
                    <div
                      slot="title"
                      class="m-display-flex space-between align-middle"
                      v-if="item.no_manifest"
                    >
                      <span>{{ item.no_manifest }}</span>
                    </div>
                    <div slot="description" v-if="item.tgl_mulai_dinas">
                      <span
                        >{{
                          moment(
                            item.tgl_mulai_dinas,
                            getStandartFormatDate
                          ).format('DD-MM-YYYY')
                        }}
                        -
                        {{
                          moment(
                            item.tgl_selesai_dinas,
                            getStandartFormatDate
                          ).format('DD-MM-YYYY')
                        }}</span
                      >
                    </div>
                    <div slot="description">
                      <div class="m-width-full">
                        <a-tooltip
                          class="ant-tooltip-inner"
                          placement="top"
                          :title="
                            item.deskripsi
                              ? item.deskripsi
                              : 'Tidak ada deskripsi'
                          "
                        >
                          <span class="ant-description-ellipses">{{
                            item.deskripsi
                              ? item.deskripsi
                              : "Tidak ada deskripsi"
                          }}</span>
                        </a-tooltip>
                      </div>
                      <template>
                        <a-tag
                          v-if="item.upload_status == '1'"
                          color="green"
                          class="margin-remove"
                          style="'width:50%;text-align: center'"
                          >File Have Been Uploaded
                        </a-tag>
                        <a-tag
                          v-else
                          color="grey"
                          class="margin-remove"
                          style="'width:50%;text-align: center'"
                          >No File Uploaded
                        </a-tag>
                      </template>
                    </div>
                    <div slot="title" v-if="item.value_transaksi">
                      <span class="m-timeline-title">{{
                        formatCurrency(data.mata_uang, item.value_transaksi)
                      }}</span>
                    </div>
                  </a-list-item-meta>
                </a-list-item>
              </a-list>
            </a-collapse-panel>
          </a-collapse>
          <template v-if="getScreen">
            <a-card
              class="margin-top"
              :loading="pageLoading"
              v-if="
                data.jenis.toLowerCase() !== 'manifest' &&
                data.jenis.toLowerCase() !== 'transfer'
              "
            >
              <div slot="title">Manifest Actions</div>

              <a-form :form="form">
                <a-form-item label="Note">
                  <a-textarea
                    placeholder="Write the note here ... "
                    :rows="4"
                    v-decorator="['catatan']"
                  />
                </a-form-item>
                <a-form-item label="Aksi">
                  <a-select
                    showSearch
                    v-decorator="['aksi', { rules: [{ required: true }] }]"
                  >
                    <a-select-option
                      v-for="item in data.aksi"
                      :key="item.aksi"
                      >{{ item.aksi }}</a-select-option
                    >
                  </a-select>
                </a-form-item>
              </a-form>
              <template class="ant-card-actions" slot="actions">
                <a-button
                  @click="handleActionConfirm"
                  block
                  type="primary"
                  html-type="submit"
                  >Save</a-button
                >
              </template>
            </a-card>
            <a-card
              class="margin-top"
              :loading="pageLoading"
              v-if="data.jenis.toLowerCase() === 'transfer'"
            >
              <div slot="title">
                Manifest Actions &nbsp;<i
                  v-if="data.jenis == 'Transfer' && !data.status_transfer"
                  style="color: red !important"
                  >(Funding has not been set)</i
                >
              </div>
              <div slot="extra">
                <h5 class="m-text-align right margin-remove">
                  Remaining Balance
                </h5>
                <a-tag color="green">
                  {{ formatCurrency(data.currency, data.sisa_tf) }}
                </a-tag>
              </div>
              <template
                v-if="!(data.jenis == 'Transfer' && !data.status_transfer)"
              >
                <a-form :form="form">
                  <a-form-item label="Aksi">
                    <a-select
                      showSearch
                      @change="changeAction"
                      v-decorator="['status', { rules: [{ required: true }] }]"
                    >
                      <a-select-option
                        v-for="item in data.aksi"
                        :key="item.aksi"
                        >{{ item.aksi }}</a-select-option
                      >
                    </a-select>
                  </a-form-item>
                  <a-form-item
                    label="Transfer Date"
                    v-if="aksiSelected === 'Transferred' || aksiSelected === ''"
                  >
                    <a-date-picker
                      placeholder="Select Date"
                      :format="getDefaultDateFormat"
                      v-decorator="['tgl_trf', { rules: [{ required: true }] }]"
                    />
                  </a-form-item>
                  <a-form-item
                    label="Evidence of Transfer"
                    v-if="aksiSelected === 'Transferred' || aksiSelected === ''"
                  >
                    <a-upload
                      accept="image/*"
                      :showUploadList="true"
                      :fileList="push"
                      :remove="handleRemoveList"
                      listType="picture"
                      :beforeUpload="beforeUpload"
                      v-decorator="[
                        'upload',
                        { rules: [{ required: true }] },
                        { valuePropName: 'push' },
                      ]"
                    >
                      <a-button>
                        <a-icon type="upload" />&nbsp;Select File
                      </a-button>
                    </a-upload>
                  </a-form-item>
                  <a-form-item
                    label="Transfer Value"
                    v-if="aksiSelected === 'Transferred' || aksiSelected === ''"
                  >
                    <a-input-number
                      :disabled="disabled"
                      type="number"
                      :max="data.sisa_tf"
                      class="m-width-full m-text-align right"
                      v-decorator="[
                        'value_transferan',
                        { rules: [{ required: true }] },
                      ]"
                    />
                  </a-form-item>
                  <a-checkbox
                    v-if="aksiSelected === 'Transferred' || aksiSelected === ''"
                    class="margin-bottom"
                    @change="handleCheckData"
                    :checked="checkTransferValue"
                    >The transferred value matches the remaining
                    balance</a-checkbox
                  >
                  <a-form-item label="Note">
                    <a-textarea
                      placeholder="Write the note here ... "
                      :rows="4"
                      v-decorator="['remark']"
                    />
                  </a-form-item>
                </a-form>
                <template class="ant-card-actions" slot="actions">
                  <a-button
                    @click="handleActionConfirm"
                    block
                    type="primary"
                    html-type="submit"
                    >Save</a-button
                  >
                </template>
              </template>
            </a-card>
          </template>
        </a-col>
      </a-row>
    </div>
    <a-modal v-model="visibleHistory" @ok="historyToggle" :footer="null">
      <span slot="title"> <a-icon type="reload" />&nbsp;History Status </span>

      <ul class="m-list-wrapper bordered">
        <li v-for="history in data.history" :key="history.id_notifikasi">
          <div v-if="history.aksi === '1' || history.aksi === '3'">
            <div class="m-display-flex space-between">
              <h3 class="margin-remove m-list-title">
                {{ history.as_from }}
                {{ history.tlc_from ? "|" + history.tlc_from : "" }}
              </h3>
              <Status :status="history.deskripsi" />
            </div>
            <span class="m-list-desc">{{ history.tgl_notif }}</span>
          </div>
          <div v-else-if="history.aksi === '2' || history.aksi === '4'">
            <div class="m-display-flex space-between">
              <h3
                class="margin-remove m-list-title"
                v-if="history.aksi === '4' && history.deskripsi === 'Edited'"
              >
                {{ history.as_from }}
                {{ history.tlc_from ? "|" + history.tlc_from : "" }}
              </h3>
              <h3 class="margin-remove m-list-title" v-else>
                {{ history.as_to }}
                {{ history.tlc_to ? "|" + history.tlc_to : "" }}
              </h3>
              <Status :status="history.deskripsi" />
            </div>
            <span class="m-list-desc">{{ history.tgl_notif }}</span>
          </div>
        </li>
      </ul>
    </a-modal>
    <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
      <div class="margin-top"></div>
      <a-divider class="margin-small" />
      <img alt="example" style="width: 100%" :src="previewImage" />
    </a-modal>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import lottie from "vue-lottie";
import Status from "@/components/Status.vue";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import HandleRoute from "@/mixins/HandleRoute";
import moment from "moment";

export default {
  name: "ManifestAccountMutation",
  components: { "m-anim": lottie, Status },
  props: ["id", "user_pembuat"],
  mixins: [CurrencyFormat, HandleRoute],
  data() {
    return {
      status_transfer: true,
      previewVisible: false,
      previewImage: "",
      visibleHistory: false,
      pageLoading: false,
      disabled: true,
      data: {
        header_1: {
          create_dt: moment(),
        },
        user_pembuat: {
          tlc: "",
        },
        jenis: "",
        last_status: null,
        sisa_tf: null,
        aksi: null,
        bukti_transfer: [],
        // detail_invoice: [],
        // dokumen_terkait: {
        //   tlc:""
        // },
        status: [],
        history: [],
        currency: "IDR",
        workflow: {
          tlc: "",
        },
      },
      push: [],
      pagination: {
        onChange: (page) => {
          console.log(page);
        },
        pageSize: 5,
        size: "small",
      },
      tableData: [],
      tableDataTemp: [],
      search: "",
      aksiSelected: "",
      checkTransferValue: true,
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getDefaultDateFormat",
      "getIsSpecialMenu",
      "getDateTimeFormat",
      "getStandartFormatDate",
    ]),
    columns() {
      let { sortedInfo, filteredInfo } = this;
      sortedInfo = sortedInfo || {};
      filteredInfo = filteredInfo || {};

      const kolom = [
        {
          title: "No",
          dataIndex: "key",
          key: "key",
          width: 60,
          sorter: (a, b) => a.no.length - b.no.length,
          footer: () => {
            return "<div>Summary</div>";
          },
        },
        {
          title: "Item Name",
          dataIndex: "item_nm",
          key: "item_nm",
          width: 200,
          sorter: (a, b) => a.item_nm.length - b.item_nm.length,
        },
        {
          title: "Unit Price",
          dataIndex: "harga",
          key: "harga",
          width: 100,
          sorter: (a, b) => a.kredit.length - b.kredit.length,
          scopedSlots: { customRender: "harga" },
        },
      ];
      return kolom;
    },
    searching() {
      let self = this;
      if (this.search) {
        self.tableData = this.tableData.filter(
          (obj) =>
            obj.item_nm.toLowerCase().indexOf(this.search.toLowerCase()) >= 0
        );
      }

      if (!this.search) {
        self.tableData = this.tableDataTemp;
      }

      return this.tableData;
    },
  },
  methods: {
    moment,
    fetchManifest() {
      this.pageLoading = true;
      axios({
        method: "get",
        url: this.$serviceUrl + "account_mutation",
        params: {
          id_account_mutation: this.id,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.data = {
            header_1: {
              am_no: response.data.header_1[0].am_no,
              tlc_create: response.data.header_1[0].tlc_create,
              acc_from: response.data.header_1[0].acc_from,
              value: response.data.header_1[0].value,
              acc_to: response.data.header_1[0].acc_to,
              currency: response.data.header_1[0].currency,
              description: response.data.header_1[0].description,
              create_dt: response.data.header_1[0].create_dt,
              kurs: response.data.header_1[0].kurs,
              file_name: response.data.header_1[0].file_name,
              file_path: response.data.header_1[0].file_path,
            },
            bukti_transfer: response.data.bukti_tf,
            dokumen_pendukung: response.data.data_pendukung,
            currency: response.data.header_1[0].currency,
            currency_to: response.data.header_1[0].currency_to,
            jenis: response.data.jenis,
            last_status: response.data.header_1[0].status,
            user_pembuat: {
              tlc: response.data.header_1[0].tlc_create,
              tanggal: response.data.header_1[0].create_dt,
              status: "Created",
            },
            sisa_tf: response.data.sisa_tf,
            aksi: response.data.aksi,
            //bukti_transfer: response.data.detail_bukti_transfer,
            //detail_invoice: response.data.header_2,
            dokumen_terkait: response.data.related_dokumen,
            status: response.data.status_transaksi[0].wf_status,
            history: response.data.status_transaksi[0].history,
            status_transfer: response.data.status_transfer,
          };

          this.currency = response.data.header_1[0].currency;

          //usage detil
          this.tableData = response.data.header_2;
          this.tableDataTemp = response.data.header_2;
          //end

          this.pageLoading = false;
        })
        .catch((err) => {
          if (!err.response) {
            let responses = Object.assign({}, err.response.data);
            this.displayMessageValue("error", responses);
            this.$router.go(-1);
          } else {
            this.displayMessage("denied-manifest");
            this.$router.push({ name: "beranda" });
          }
          this.pageLoading = false;
        });
    },
    historyToggle(e) {
      e.stopPropagation();
      this.visibleHistory = !this.visibleHistory;
    },
    handlePrint(item) {
      this.pageLoading = true;
      axios({
        method: "get",
        url: this.$serviceUrl + "pi/cetak_laporan_um_pi",
        responseType: "blob",
        params: {
          tlc: this.getAuth.username,
          id_pi: this.id,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          let blob = new Blob([response.data], { type: "application/pdf" }),
            url = window.URL.createObjectURL(blob);
          window.open(url, "_blank");
          this.pageLoading = false;
        })
        .catch((err) => {
          if (err.response.status === 404) {
            this.displayMessage("404");
          }
          this.pageLoading = false;
          //this.$router.go(-1);
        });
    },
    handleEdit() {
      this.$router.push({
        name: "lapUmppEdit",
        params: { id: this.id, type: "revised" },
      });
    },
    handleActionConfirm() {
      this.confirmMessage("confirm-save");
    },
    handleAction() {
      if (this.data.jenis.toLowerCase() === "transfer") {
        this.form.validateFields((err, values) => {
          if (err) {
            this.displayMessage("form-warning");
            return;
          }

          if (this.push.length == 0) {
            this.displayMessage("empty-evidence");
            return;
          }
          if (values.value_transferan == 0) {
            this.displayMessage("grather0");
            return;
          } else {
            let post = new FormData();
            if (this.aksiSelected === "Revised") {
              post.append("status", values.status);
              post.append("remark", values.remark ? values.remark : "");
              post.append("tlc", this.getAuth.username);
              post.append("id_account_mutation", this.id);
            } else {
              post.append("id_account_mutation", this.id);
              post.append("tlc", this.getAuth.username);
              post.append("status", values.status);
              post.append("remark", values.remark ? values.remark : "");
              post.append(
                "tgl_transfer",
                values.tgl_trf.format(this.getStandartFormatDate)
              );
              post.append("cek_value", this.checkTransferValue ? 1 : 0);
              post.append("value_transfer", values.value_transferan);
              post.append("file_transfer", this.push[0]);
            }

            axios({
              method: "post",
              url: this.$serviceUrl + "account_mutation/approval",
              processData: false,
              data: post,
              auth: {
                username: this.getAuth.username,
                password: this.getAuth.password,
              },
              headers: {
                "Content-Type": "application/json",
                "X-API-KEY": this.getAuth.apikey,
              },
            })
              .then((response) => {
                this.displayMessage("success");
                this.$router.go();
              })
              .catch((err) => {
                let responses = Object.assign({}, err.response.data);
                if (responses.message) {
                  this.displayMessageValue("error-other", responses.message);
                } else {
                  this.displayMessageValue("error", responses);
                }
              });
          }
        });
      } else {
        this.form.validateFields((err, values) => {
          if (err) {
            this.displayMessage("choose-action");
            return;
          }

          axios({
            method: "post",
            url: this.$serviceUrl + "account_mutation/approval ",
            processData: false,
            data: {
              id_account_mutation: this.id,
              tlc: this.getAuth.username,
              status: values.aksi,
              remark: values.catatan,
            },
            auth: {
              username: this.getAuth.username,
              password: this.getAuth.password,
            },
            headers: {
              "Content-Type": "application/json",
              "X-API-KEY": this.getAuth.apikey,
            },
          })
            .then((response) => {
              this.displayMessage("success");
              this.$router.go();
            })
            .catch((err) => {
              console.log("error : " + err);
            });
        });
      }
    },
    handleCheckData(e) {
      if (e.target.checked) {
        this.disabled = true;
        this.checkTransferValue = true;
        this.form.setFieldsValue({
          value_transferan: this.data.sisa_tf,
        });
      } else {
        this.disabled = false;
        this.checkTransferValue = false;
        this.form.setFieldsValue({
          value_transferan: 0,
        });
      }
    },
    beforeUpload(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 30) {
        this.displayMessage("large-file-2mb");
      } else {
        this.push = [file];
        return false;
      }
    },
    handleRemoveList(file) {
      const index = this.push.indexOf(file);
      const newFileList = this.push.slice();
      newFileList.splice(index, 1);
      this.push = newFileList;
    },
    handleCancel() {
      this.previewVisible = false;
    },
    handleViewDt(file) {
      let tipe = file.path.substr(file.path.length - 3);
      if (tipe == "jpg" || tipe == "jpeg" || tipe == "png") {
        this.previewImage = this.$serviceUrl + file.path;
        this.previewVisible = true;
      } else {
        window.open(this.$serviceUrl + file.path, "_blank");
      }
    },
    changeAction(item) {
      this.aksiSelected = item;
    },
    handleDownload(item) {
      window.open(this.$serviceUrl + item.path, "_blank");
    },
    handleViews(item) {
      item.id_manifest = item.id;
      this.handleView(item);
    },
    handlePreview(url) {
      window.open(this.$serviceUrl + url, "_blank");
    },
  },
  created() {},
  watch: {
    id() {
      if (this.id) {
        this.fetchManifest();
        this.form = this.$form.createForm(this);
        this.push = [];
        this.checkTransferValue = true;
        this.disableNilaiTf = false;
        this.search = "";
      }
    },
  },
  mounted() {
    Event.$on("confirmMessageReturn", this.handleAction);
    this.fetchManifest();
  },
  beforeDestroy() {
    Event.$off("confirmMessageReturn", this.handleAction);
  },
};
</script>

<style scoped lang="less">
.m-image-icon {
  width: 50px;
}
</style>
